import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { PLCheckUserStatus, PLLoginRedirect, selectAuthState } from '../store';

@Injectable()
export class UserAuthGuardService {
  constructor(private store: Store) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(selectAuthState).pipe(
      mergeMap((authState) => {
        switch (authState) {
          case 'init':
            this.store.dispatch(PLCheckUserStatus({ lastActive: 0 }));
            return EMPTY;
          case 'error':
            this.store.dispatch(PLLoginRedirect({ url: state.url }));
            return EMPTY;
          case 'success':
            return of(true);
          case 'pending':
          default:
            return EMPTY;
        }
      }),
      first()
    );
  }
}
